export default __webpack_public_path__ + "cee3911f5885f05c7db4a2636d8673b4.svg";